var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.895 0 0 0.895 0 2V15C0 15.552 0.448 16 1 16C1.552 16 2 15.552 2 15V2H15C15.552 2 16 1.552 16 1C16 0.448 15.552 0 15 0H2ZM6 4C4.895 4 4 4.895 4 6V18C4 19.105 4.895 20 6 20H18C19.105 20 20 19.105 20 18V6C20 4.895 19.105 4 18 4H6ZM6 6H18V18H6V6Z",
    fill: "#265183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.471e5f706c70f48d5aee0f63f2e6a87e.svg";
export { ForwardRef as ReactComponent };